module.exports = __webpack_public_path__ + "static/media/Raleway-Medium.9c6035f5.woff2";